import React from 'react';
import $ from 'jquery';

import { eventTypes, trackEvent } from '../../helpers/AnalyticsManager';
import BorderedButton from '../../common/borderedButton/BorderedButton';
import { formatMoney } from '../../helpers/NumberHelper';
import CoverImage from '../../images/contact/contact-cover.png';

import './ContactFormSection.css';

class ContactFormSection extends React.Component {
  constructor() {
    super();

    this.state = {
      formFields: {
        BUDGET: '0',
        NAME: '',
        'E-MAIL': '',
        SUBJECT: '',
        MESSAGE: '',
        COMPANY: '',
        'JOB TITLE': '',
      },
      isLoading: false,
    };
  }

  updateInputValue(event) {
    const value = event.target.id;

    if (value !== '') {
      event.target.classList.remove('emptyField');
    }

    const { formFields } = this.state;

    this.setState({
      formFields: { ...formFields, [event.target.id]: event.target.value },
    });
  }

  submitForm() {
    const { formFields } = this.state;
    const fields = Object.keys(formFields);
    let hasEmptyFields = false;
    fields.forEach((fieldID) => {
      const { [fieldID]: answer } = formFields;
      if (answer === '') {
        document.getElementById(fieldID).classList.add('emptyField');
        hasEmptyFields = true;
      } else {
        document.getElementById(fieldID).classList.remove('emptyField');
      }
    });

    if (!hasEmptyFields) {
      document.getElementById('feedbackMessage').style.opacity = '0';
    } else {
      trackEvent(eventTypes.contactSendFail, { label: 'missing_fields' });
      document.getElementById('feedbackMessage').innerHTML = 'Please, fill all the fields before submiting.';
      document.getElementById('feedbackMessage').classList.remove('successMessage');
      document.getElementById('feedbackMessage').classList.add('errorMessage');
      document.getElementById('feedbackMessage').style.opacity = '1';
      return;
    }

    const {
      NAME, 'E-MAIL': email, SUBJECT, MESSAGE, BUDGET, COMPANY, 'JOB TITLE': jobTitle,
    } = formFields;

    const formAnswers = {
      NAME,
      'E-MAIL': email,
      SUBJECT,
      MESSAGE,
      BUDGET,
      COMPANY,
      'JOB TITLE': jobTitle,
    };

    const scriptURL = 'https://script.google.com/macros/s/AKfycbzelPCct1gou_euWJFu3OaeXrzX6QbqMMUGDFiVLGFqc9_Fg7Y/exec';

    const settings = {
      async: true,
      crossDomain: true,
      url: scriptURL,
      method: 'POST',
      data: formAnswers,
    };

    this.setState({ isLoading: true });

    $.ajax(settings)
      .done((response) => {
        trackEvent(eventTypes.contactSendSuccess);
        const { result } = response;
        if (result === 'success') {
          document.getElementById('feedbackMessage').innerHTML = 'Message sent, thank you.';
          document.getElementById('feedbackMessage').classList.remove('errorMessage');
          document.getElementById('feedbackMessage').classList.add('successMessage');
          document.getElementById('feedbackMessage').style.opacity = '1';

          this.setState({
            formFields: {
              BUDGET: '0',
              NAME: '',
              'E-MAIL': '',
              SUBJECT: '',
              MESSAGE: '',
              COMPANY: '',
              'JOB TITLE': '',
            },
            isLoading: false,
          });
        }
      })
      .fail(() => {
        trackEvent(eventTypes.contactSendFail, { label: 'send_error' });
        document.getElementById('feedbackMessage').innerHTML = 'Failed to send message. Please try again.';
        document.getElementById('feedbackMessage').classList.remove('successMessage');
        document.getElementById('feedbackMessage').classList.add('errorMessage');
        document.getElementById('feedbackMessage').style.opacity = '1';
        this.setState({ isLoading: false });
      });
  }

  render() {
    const {
      formFields: {
        BUDGET: budget,
        NAME: name,
        'E-MAIL': email,
        SUBJECT: subject,
        MESSAGE: message,
        COMPANY: company,
        'JOB TITLE': jobTitle,
      },
      isLoading,
    } = this.state;

    return (
      <div id="ContactFormSection">
        <img id="ContactCoverImage" src={CoverImage} alt="" />
        <div id="contactForm">
          <h1>
            Como podemos
            <br />
            colaborar?
          </h1>
          <form action="" id="login-form">
            <input
              value={name}
              type="text"
              className="underlinedInput"
              id="NAME"
              placeholder="NOME"
              onChange={evt => this.updateInputValue(evt)}
            />
            <input
              value={email}
              type="text"
              className="underlinedInput"
              id="E-MAIL"
              placeholder="E-MAIL"
              onChange={evt => this.updateInputValue(evt)}
            />
            <input
              value={company}
              type="text"
              className="underlinedInput"
              id="COMPANY"
              placeholder="COMPANHIA"
              onChange={evt => this.updateInputValue(evt)}
            />
            <input
              value={jobTitle}
              type="text"
              className="underlinedInput"
              id="JOB TITLE"
              placeholder="CARGO"
              onChange={evt => this.updateInputValue(evt)}
            />
            <input
              value={subject}
              type="text"
              className="underlinedInput"
              id="SUBJECT"
              placeholder="ASSUNTO"
              onChange={evt => this.updateInputValue(evt)}
            />
            <textarea
              value={message}
              className="messageInput"
              rows="5"
              id="MESSAGE"
              placeholder="MENSAGEM"
              onChange={evt => this.updateInputValue(evt)}
            />
            <div className="slidecontainer">
              <div id="slideTitle">
                <h2>ORÇAMENTO</h2>
                <p>
                  { (budget === '0') && 'Não Definido' }
                  { (budget > 0 && budget < 1000000) && `$ ${formatMoney(budget, 2, ',', '.')}`}
                  { (budget === '1000000') && `Over $ ${formatMoney(budget, 2, ',', '.')}`}
                </p>
              </div>
              <input
                value={budget}
                type="range"
                min="0"
                max="1000000"
                step="50000"
                className="slider"
                id="BUDGET"
                onChange={evt => this.updateInputValue(evt)}
              />
            </div>
            <p id="feedbackMessage" />

            <BorderedButton
              title="Send"
              onClick={() => this.submitForm()}
              id="send-button"
              loading={isLoading}
            />
          </form>
        </div>
      </div>
    );
  }
}

export default ContactFormSection;
